<mat-card>
  <mat-toolbar>{{title}}
    <span class="fill-remaining-space"></span>
    <button mat-icon-button matTooltip="Mostrar/ocultar cercador" aria-label="Mostrar/ocultar cercador" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-left:10px;matInput margin-right: 0">
      <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-documents-filtres
      *ngIf="showFilters"
      [validFilters]="documentsFilters"
      (changeFilter)="computeActiveFilters($event)"
      >
    </mcrit-gestio-documents-filtres>
    <span class="mat-button-wrapper" style="width:100%">
      <mat-icon color="primary" matTooltip="Afegeix-me" aria-label="Afegeix-me" matTooltipClass="tooltip-style" style="font-size:24px;cursor:pointer;float:right;padding:10px" (click)="addDocument()">person_add</mat-icon>
    </span>
     <table style="padding-top:40px">
      <thead>
        <tr>
          <th></th>
          <th (click)="cycleOrdering('titol')" style="width:25%">Títol
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['titol'] === 1 ?'keyboard_arrow_up' :(orderingParameters['titol'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:45%">Descripció
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['descripcio'] === 1 ?'keyboard_arrow_up' :(orderingParameters['descripcio'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th (click)="cycleOrdering('tipus')" style="width:10%">Tipus
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['tipus'] === 1 ?'keyboard_arrow_up' :(orderingParameters['tipus'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:15%;text-align: right" (click)="cycleOrdering('data_doc')">Data
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['data_doc'] === 1 ?'keyboard_arrow_up' :(orderingParameters['data_doc'] === 2 ?
                  'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
          <th style="width:5%;text-align: right" (click)="cycleOrdering('fitxer')">Fitxer
            <mat-icon style="vertical-align: middle">
              {{(
                 orderingParameters['fitxer'] === 1 ?'keyboard_arrow_up' :(orderingParameters['fitxer'] === 2 ?'keyboard_arrow_down' : '')
              )}}
            </mat-icon>
          </th>
    </tr>
      </thead>
      <tbody *ngIf="elementList">
          <tr *ngFor="let fdocuments of elementList.rows; let j = index" style="cursor:pointer">
            <td>
             <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="deleteDocument(fdocuments.id)" matTooltip="Esborrar el document" aria-label="Esborrar el document" matTooltipClass="tooltip-style">
                <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
             </button>
            </td>
            <td (click)="editDocument(fdocuments)">
              {{fdocuments.titol}}
            </td>
            <td style="text-align: left" (click)="editDocument(fdocuments)">
              {{fdocuments.descripcio}}
            </td>
            <td style="text-align: right" (click)="editDocument(fdocuments)">
              {{fdocuments.tipus}}
            </td>
            <td style="text-align: right" (click)="editDocument(fdocuments)">
              {{fdocuments.data_doc | date}}
            </td>
            <td style="text-align: right">
              <a href="./assets/documents/documents/{{fdocuments.fitxer}}" target="_blank"><mat-icon style="font-size:24px">cloud_download</mat-icon></a>
            </td>
          </tr>
        </tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      Línies per pàgina: {{listService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="elementList">
      {{firstRegisterShown}} - {{lastRegisterShown}} de {{elementList.registers}} documents
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
